import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AudioRecordingService {

    recordingInProgress$: Observable<boolean> = new BehaviorSubject<boolean>(false);

    set recordingInProgress(inProgress: boolean) {
        (this.recordingInProgress$ as BehaviorSubject<boolean>).next(inProgress);
    }

    get recordingInProgress() :boolean {
        return (this.recordingInProgress$ as BehaviorSubject<boolean>).value;
    }
}